import { rankingList } from '@/mocks/anime';

const trendMap: Record<string, { icon: string; className: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', className: 'text-primary-600 bg-primary-100', label: '上升' },
  down: { icon: 'ri-arrow-down-line', className: 'text-foreground-500 bg-background-200', label: '下降' },
  flat: { icon: 'ri-subtract-line', className: 'text-secondary-700 bg-secondary-100', label: '持平' },
};

export default function RankingSection() {
  const topThree = rankingList.slice(0, 3);
  const rest = rankingList.slice(3);

  return (
    <section id="ranking" className="bg-background-100 py-14 md:py-20 border-y border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-medium tracking-wide text-primary-600">本周排行榜</span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            这周被看得最多的作品
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
            排名依据本周的浏览与观看热度综合整理，只反映关注度，不代表作品质量的最终评价。想快速挑一部开始，可以先从前三名看起。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {topThree.map((item) => (
            <div
              key={item.rank}
              className="relative rounded-lg bg-background-50 border border-background-200 p-5"
            >
              <span className="absolute -top-3 -left-2 w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 font-heading text-lg font-bold">
                {item.rank}
              </span>
              <div className="pt-4">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                <div className="mt-2 flex items-center gap-2 text-xs">
                  <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">{item.genre}</span>
                  <span className="flex items-center gap-1 text-foreground-600">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.heat}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 rounded-lg bg-background-50 border border-background-200 divide-y divide-background-200">
          {rest.map((item) => {
            const trend = trendMap[item.trend];
            return (
              <div
                key={item.rank}
                className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5 px-4 md:px-5 py-4"
              >
                <div className="flex items-center gap-4 sm:w-16">
                  <span className="font-heading text-lg font-bold text-foreground-400 w-6 text-center">
                    {item.rank}
                  </span>
                  <span className={`flex items-center gap-0.5 px-1.5 py-0.5 rounded text-xs ${trend.className}`}>
                    <i className={trend.icon}></i>
                    {trend.label}
                  </span>
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                    <span className="px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-900">
                      {item.genre}
                    </span>
                  </div>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
                </div>

                <div className="flex items-center gap-2 text-sm text-foreground-700 sm:w-28 sm:justify-end">
                  <i className="ri-fire-line text-primary-500"></i>
                  {item.heat}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}